import Select from "../../../../form/Select";
import React, {Fragment} from "react";
import {PartnerSelect} from "../../../../../utils/formatters";
import ModalEditor from "src/components/editors/ModalEditor";
import classNames from "classnames";
import Button from "src/components/form/Button";
import PartnerEditor from "src/components/editors/partnerEditor";

export default (propsTop) => {
    const {props} = propsTop;
    const {hidden} = props;
    const values = propsTop.values || props.values;
    const getFieldProps = propsTop.getFieldProps || props.getFieldProps;
    const setFieldValue = propsTop.setFieldValue || props.setFieldValue;
    const currentProps = getFieldProps("seller");
    return (hidden || []).indexOf("seller") === -1 && <Fragment>
        <label className="control-label">{propsTop.label || "Eladó"}</label>
        <div className="input-group">
            <PartnerEditor
                editorContext="SellerPartnerEditor"
                editor={ModalEditor}
                other={() => null}
                selection={null}
                newButton={(props) => {
                    return <Button
                        type="button"
                        {...props}
                        disabled={props.disabled || propsTop.disabled || currentProps.disabled}
                        children=""
                        color="default"
                        icon={{lib: "fas", name: "search"}}
                        className="pull-left"
                    />
                }}
                list={(listProps) => {
                    return <Fragment>
                        <div className="input-group-btn">
                            {listProps.footer}
                        </div>
                    </Fragment>;
                }}
                onPartnerSelected={async (data, componentConfig, editorProps) => {
                    props.setFieldValue("seller", data);
                    await editorProps.setFormValues({});
                }}
                saveForm={async (data, componentConfig, editorProps) => {
                    props.setFieldValue("seller", data);
                    await editorProps.setFormValues({});
                }}
            />
            <Select
                label={false}
                name="seller"
                component="partner"
                optionsTemplate={PartnerSelect}
                objectValue={true}
                labelKey="name"
                valueKey="partner_id"
                storeType="remote"
                {...currentProps}
                disabled={propsTop.disabled || currentProps.disabled}
                value={values.seller}
                saveChanges={setFieldValue}
            />
        </div>
    </Fragment>;
}